// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"ba7ca2bf","44":"3fdacee7","475":"2599c380","936":"b0c45c82"}[chunkId] + ".chunk.js";
};